import * as React from 'react'
import safeZoneStore from '../../store/safeZoneStore.ts'

export const NewSafeZone: React.FC = () => {
    const newSafeZone = safeZoneStore(s => s.newSafeZone)
    return <>{newSafeZone}</>
}
